// Project/highways/HighwayPage.jsx

import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../../config/axios";
import Dashboardnavbar from "../../../layout/Dashboardnavbar";
import HighwayProjects from "./HighwayProjects";
import HighwaySections from "./HighwaySections";
import AddHighwayProject from "./AddHighwayProject";
import { AddProjectDetails } from "../ProjectDetailsCrud/ProjectDetailsCRUD";
import ProjectFilter from "../Projectname/ProjectFilter";
import SectionFilter from "../ProjectDetailsCrud/SectionFilter";

const HIGHWAY_SECTOR_UUID = "9d74ca44-5bff-4ecb-afac-aba5663eb2d0";

const HighwayPage = () => {
    const [toggleState, setToggleState] = useState(1);
    const [buffer, setBuffering] = useState(false);
    const [projectName, setProjectName] = useState([]);
    const [project, setProject] = useState([]);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1: return "Highway Project Details";
            case 2: return "Highway Section Details";
            default: return "Project";
        }
    };

    const getProjectname = async (filters = null) => {
        setBuffering(true);
        try {
            let res;
            if (filters) {
                const url = `${BASE_URL}/dpr/projectdetailsmultiplefilter/${filters.project || "null"}/${filters.sector || "null"}/${filters.workType || "null"}/${filters.companyName || "null"}/${filters.loaStartDate || "null"}/${filters.loaEndDate || "null"}/${filters.completionStartDate || "null"}/${filters.completionEndDate || "null"}/`;
                res = await axios.get(url);
            } else {
                res = await axios.get(`${BASE_URL}/dpr/projectdetailsfiltersector/${HIGHWAY_SECTOR_UUID}/`);
            }
            setProjectName(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setBuffering(false);
        }
    };

    const getProject = async (filters = null) => {
        setBuffering(true);
        try {
            let result;
            if (filters) {
                const safe = (val) => (val ? val : "null");
                const url = `${BASE_URL}/dpr/sectionmultiplefilter/${safe(filters.project)}/${safe(filters.section)}/${safe(filters.location)}/${safe(filters.workStage)}/${safe(filters.minLength)}/${safe(filters.maxLength)}/${safe(filters.minCost)}/${safe(filters.maxCost)}/`;
                result = await axios.get(url);
            } else {
                result = await axios.get(`${BASE_URL}/dpr/projectfiltersubconsultant/${HIGHWAY_SECTOR_UUID}/`);
            }
            setProject(result.data);
        } catch (err) {
            console.error(err);
        } finally {
            setBuffering(false);
        }
    };

    const handleProjectFilter = (filters) => getProjectname(filters);
    const handleSectionFilter = (filters) => getProject(filters);

    useEffect(() => { getProjectname(); }, []);
    useEffect(() => { getProject(); }, []);

    return (
        <div>
            <Dashboardnavbar name={getSelectedTitle()} url={"Project Management"} />

            <div className="content-tabs">
                <div className='toggle-button-area flex-row justify-between' style={{ padding: "15px 30px" }}>
                    <div className='flex-row justify-between' style={{ width: "100%" }}>
                        <div>
                            <button
                                className={toggleState === 1 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
                                onClick={() => setToggleState(1)}
                            >
                                Highway Project Details
                            </button>
                            <button
                                className={toggleState === 2 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
                                onClick={() => setToggleState(2)}
                            >
                                Highway Section Details
                            </button>
                        </div>

                        {toggleState === 1
                            ? <AddHighwayProject getProjectname={getProjectname} useFor="table" />
                            : <AddProjectDetails getProject={getProject} project={project} ProjectDetails={projectName} usedFor="Highway" />
                        }
                    </div>
                </div>

                <div style={{ padding: "0 30px" }}>

                    {toggleState === 1 && (
                        <>
                            <ProjectFilter onApply={handleProjectFilter} hideSector={true} />
                            <HighwayProjects
                                projectName={projectName}
                                getProjectname={getProjectname}
                                getProject={getProject}
                                buffer={buffer}
                                hideSector={true}
                            />
                        </>
                    )}

                    {toggleState === 2 && (
                        <>
                            <SectionFilter onApply={handleSectionFilter} sectionData={project} />
                            <HighwaySections
                                project={project}
                                getProject={getProject}
                                buffer={buffer}
                                ProjectDetails={projectName}
                                hideSector={true}
                            />
                        </>
                    )}

                </div>
            </div>
        </div>
    );
};

export default HighwayPage;